import { client } from '../http';

export default {
  async getPromotion(promoCode) {
    const response = await client.get(`/api/no-auth/promotion/${promoCode}`);
    return response.data;
  },
};
